import { Theme } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/styles";
import styled from "styled-components";

export const MenuItem = styled.li`
  display: flex;
  padding-right: 30px;
  padding-left: 30px;
  position: relative;
  height: 4rem;
`;
export const CollapseItem = styled.li`
  display: flex;
  padding-right: 17px;
  padding-left: 17px;
  position: relative;
  height: 2.5rem;
  align-items: center;
`;

export const useNavStyles = makeStyles((theme: Theme) =>
  createStyles({
    ulStyled: {
      fontSize: 11,
      display: "flex",
      textTransform: "capitalize",
      height: "100%",
      position: "relative",
      alignItems: "center",
    },
    ulListStyle: {
      width: "100%",
      height: "100%",
      backgroundColor: "#1a224b",
      overflowY: "auto",
      overflowX: "unset",
    },
    ulDivStyled: {
      display: "inline-flex",
      cursor: "pointer",
      margin: "auto",
    },
    appBar: {
      width: "100%",
      justifyContent: "center",
      backgroundColor: "#1a224b",
    },
    iconStyle: {
      color: "#fff",
    },
    collapsed: {
      backgroundColor: "rgb(255, 255, 255)",
      width: "84%",
      marginLeft: "8%",
      borderRadius: "10px",
    },
    collapsedProfile: {
      backgroundColor: "rgb(255, 255, 255)",
      width: "84%",
      marginLeft: "8%",
      borderRadius: "5px",
      padding: "5px",
    },
    collapsedList: {
      height: "3rem",
    },
    expendIcon: {
      marginLeft: "15rem",
      [theme.breakpoints.up(320)]: {
        marginLeft: "8rem",
      },
      [theme.breakpoints.up(375)]: {
        marginLeft: "12rem",
      },
      [theme.breakpoints.up(425)]: {
        marginLeft: "15rem",
      },
    },
    logoStyled: {
      maxWidth: "150px",
    },
    iconButtonStyle: {
      display: "flex",
      marginLeft: "auto",
    },
    items: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      color: "#399ebf",
    },
    userGrid: {
      display: "flex",
      flexDirection: "column",
      marginLeft: "3px",
    },
    jobSpan: {
      color: "#f2994a",
      fontWeight: 500,
      marginTop: "5px",
      fontSize: "12px",
    },
    checkbox: {
      paddingRight: "12px",
      "& MuiCheckbox-root": {
        margin: "0px",
      },
    },
    gridCheckbox: {
      display: "flex",
      alignItems: "flex-start",
      "& > p": {
        marginTop: "7px",
      },
    },
    logOut: {
      backgroundColor: "rgba(227, 48, 48, 0.7)",
      height: "40px",
      display: "flex",
      justifyContent: "center",
      color: "#fff",
      fontWeight: 500,
      alignItems: "center",
    },
  })
);

export const useApBarStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: "#1a224b",
      display: "flex",
      justifyContent: "space-between",
    },
    left: {
      display: "flex",
      height: "100%",
      width: "100%",
    },
    right: {
      display: "flex",
      justifyItems: "end",
      marginLeft: "auto",
      [theme.breakpoints.down("xs")]: {
        display: "none",
      },
    },
    toolbar: {
      marginTop: "auto",
      marginBottom: "auto",
      flexGrow: 1,
      width: "auto",
      "@media(max-width: 1215px)": {},
    },

    bagde: {
      marginTop: "auto",
      marginBottom: "auto",
      paddingRight: 30,
      paddingLeft: 30,
    },
    menu: {
      height: "100%",
      width: "75%",
      marginLeft: "-160px",
      [theme.breakpoints.down("xs")]: {
        display: "none",
      },
    },
    menuButton: {
      display: "none",
      [theme.breakpoints.down("xs")]: {
        display: "flex",
      },
    },
  })
);
